/*
 * Общие наборы классов для двух оболочек меню.
 *
 * `dropdown-menu.tsx` и `context-menu.tsx` описывают один и тот же вид — так
 * решено в системе: во всплывающем списке вид один. Пункты и поверхность там
 * повторены намеренно (компоненты Radix разные, общего предка нет), но
 * вложенное меню появилось позже и сразу в двух местах — а два описания одного
 * расходятся, это здесь уже проверено на дорожке ползунка.
 *
 * Поэтому то, что добавляется после, живёт одной строкой на оба файла.
 */

/*
 * Вид из макета v6: пункты-капсулы по 36px, подсветка одна на меню и едет к
 * пункту под курсором (`MenuPlate`). Своей подложки у пункта поэтому нет — её
 * рисует подсветка.
 */

/** Поверхность меню: материал «Почты», вырастает из кнопки или точки открытия (`GrowLayer` внутри). */
export const MENU_CONTENT = "z-40 flex w-[248px] flex-col p-[6px] rounded-[26px] pop-grow";

/** Пункт меню. */
export const MENU_ITEM = [
  "relative flex h-[36px] w-full shrink-0 cursor-pointer items-center gap-[11px] rounded-[var(--radius-pill)] px-[14px]",
  "text-left text-[13.5px] font-medium text-foreground outline-none select-none",
  "transition-transform duration-[400ms] ease-[var(--ease-spring)] active:scale-[1.03]",
  "data-[variant=destructive]:text-destructive",
  // Запланированное видно, но нажимать нечего.
  "data-[disabled]:cursor-default data-[disabled]:opacity-45",
].join(" ");

/** Подпись к набору: чему меню принадлежит. */
export const MENU_LABEL =
  "flex h-[30px] items-end px-[14px] pb-[6px] text-[10.5px] font-semibold tracking-[0.09em] text-dim";

export const MENU_SEPARATOR = "mx-[12px] my-[5px] h-px shrink-0 bg-border";

export const MENU_SHORTCUT = "ml-auto text-[11px] whitespace-nowrap text-dim";

/** Пункт, открывающий вложенное меню: тот же пункт плюс стрелка справа. */
export const SUB_TRIGGER = [
  MENU_ITEM,
  // Открытое вложенное держит подсветку: иначе непонятно, чьё оно.
  "data-[state=open]:bg-[image:var(--ui-glass-pick)] data-[state=open]:shadow-[var(--ui-pick-shadow)]",
].join(" ");

/** Поверхность вложенного меню — та же, что у обычного. */
export const SUB_CONTENT = "z-40 flex min-w-[196px] flex-col p-[6px] rounded-[26px] pop-grow";

/*
 * Меню по правой кнопке — на материале «Почты» (`surface-pop`, решили
 * 2 ноября): та же форма и пункты, появляется пружиной от точки щелчка
 * (`menu-pop` в `ui.css`). Меню с кнопкой — тот же материал, но вырастает из
 * кнопки (`pop-grow`).
 */
export const POP_CONTENT = "z-40 flex w-[248px] flex-col p-[6px] rounded-[26px] surface-pop menu-pop";

/** Вложенное меню по правой кнопке — тот же материал. */
export const POP_SUB_CONTENT = "z-40 flex min-w-[196px] flex-col p-[6px] rounded-[26px] surface-pop menu-pop";
